const serialize = value => JSON.stringify(value);
const deserialize = value => JSON.parse(value);

export const save = (key, value) => localStorage.setItem(key, serialize(value));

export const load = key => deserialize(localStorage.getItem(key));

export const remove = key => localStorage.removeItem(key);



// WEBPACK FOOTER //
// ./app/javascript/common/utils/storage/core.js